import { GA_MEASUREMENT_ID } from '@/const/ga'

export const pageview = (url: string) => {
  if (!GA_MEASUREMENT_ID) return
  window.gtag('config', GA_MEASUREMENT_ID, {
    page_path: url,
  })
}
